export default __webpack_public_path__ + "static/media/cp_geo_ky.63d8f295.svg";